import React from "react";
import {
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Input
} from "reactstrap";

import { PictureUpload } from "components";
import Select from "react-select";
import { validateSpanishId } from "spain-id";

var fiscalIdType = [
  { value: "93", label: "DNI" },
  { value: "94", label: "NIE" },
  { value: "96", label: "Pasaporte" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];

var checkIBAN = (function() {
  // use an IIFE
  // A "constant" lookup table of IBAN lengths per country
  // (the funky formatting is just to make it fit better in the answer here on CR)
  var CODE_LENGTHS = {
    AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
    CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
    FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
    HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
    LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
    MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
    RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
  };

  // piece-wise mod97 using 9 digit "chunks", as per Wikipedia's example:
  // http://en.wikipedia.org/wiki/International_Bank_Account_Number#Modulo_operation_on_IBAN
  function mod97(string) {
    var checksum = string.slice(0, 2),
        fragment;

    for(var offset = 2 ; offset < string.length ; offset += 7) {
      fragment = String(checksum) + string.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }

    return checksum;
  }

  // return a function that does the actual work
  return function (input) {
    var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
        code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/),           // match and capture (1) the country code, (2) the check digits, and (3) the rest
        digits;

    // check syntax and length
    if(!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return false;
    }

    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return letter.charCodeAt(0) - 55;
    });

    // final check
    return mod97(digits) === 1;
  };
}());

class Step1 extends React.Component {
  constructor(props) {
    super(props);
    // console.log("######### wizard data #######");
    // console.log(this.props.wizardData);
    this.state = {
      firstname: this.props.wizardData.wizardState.name,
      lastname: this.props.wizardData.wizardState.lastname,
      lastname2: this.props.wizardData.wizardState.lastname2,
      email: this.props.wizardData.wizardState.email,
      firstnameState: "",
      lastnameState: "",
      lastname2State: "",
      emailState: "",
      dni: this.cleanDNI(this.props.wizardData.wizardState.dni),
      dniState: "",
      promoCode: this.props.wizardData.wizardState.promoCode,
      fiscalIdType: this.props.wizardData.wizardState.fiscalIdType,
      dniManager: this.props.wizardData.wizardState.dniManager,
      firstnameManager: this.props.wizardData.wizardState.firstnameManager,
      lastnameManager: this.props.wizardData.wizardState.lastnameManager,
      lastname2Manager: this.props.wizardData.wizardState.lastname2Manager
    };
    this.firstNameChange = this.firstNameChange.bind(this);
    this.dniChange = this.dniChange.bind(this);
    this.lastNameChange = this.lastNameChange.bind(this);
    this.lastName2Change = this.lastName2Change.bind(this);
    this.emailChange = this.emailChange.bind(this);
    this.mobileChange = this.mobileChange.bind(this);
    this.ibanChange = this.ibanChange.bind(this);
    this.fiscalIdTypeChange = this.fiscalIdTypeChange.bind(this);

    if (this.props.wizardData.wizardState.isCreateFromRequest){
      this.state = {
        firstnameState: " has-success",
        lastnameState: " has-success",
        lastname2State: " has-success",
        emailState: " has-success",
        dniManagerState: " has-success",
        firstnameManagerState: " has-success",
        lastnameManagerState: " has-success",
        lastname2ManagerState: " has-success",
        mobileState: " has-success"
      };
      if (this.props.wizardData.wizardState.fiscalIdType) this.state.fiscalIdTypeState = " has-success";

      if (this.validateDNI(this.props.wizardData.wizardState.dni)) {
        this.state.dniState = " has-success";
      } else {
        this.state.dniState = " has-danger";
      }
      // this.dniChange({target:{value:this.props.wizardData.wizardState.dni}});
      // this.fiscalIdTypeChange(this.props.wizardData.wizardState.fiscalIdType);
    }
  }
  componentDidMount() {
    // this.dniChange(this.props.wizardData.wizardState.dni);
  }
  promoCodeChange(e) {
    this.setState({
      promoCode: e.target.value
    });
    if (e.target.value.length > 2) {
      this.setState({
        promoCodeState: " has-success"
      });
    } else {
      this.setState({
        promoCodeState: ""
      });
    }
    this.onChange("promoCode", e.target.value);
  }
  cleanDNI(dni) {
    return dni.replace(/\s/g, "").replace(/[^A-Za-z0-9]+/g,"").toUpperCase();
  }
  validateDNI(dni) {
    let regPassport = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
    let validPassport = regPassport.test(dni);
    return validateSpanishId(dni) || validPassport;
  }
  dniChange(e) {
    try {
      if (!e || !e.target || !e.target.value) return;
      e.target.value = this.cleanDNI(e.target.value);
      this.setState({
        dni: e.target.value
      });
      if (this.validateDNI(e.target.value)) {
        this.setState({
          dniState: " has-success"
        });
      } else {
        this.setState({
          dniState: " has-danger"
        });
      }
      this.onChange("dni", e.target.value);
    } catch (error) {
      console.error("Error al validar el DNI");
      console.error(error);
    }
  }
  firstNameChange(e) {
    this.setState({
      firstname: e.target.value
    });
    if (e.target.value.length > 2) {
      this.setState({
        firstnameState: " has-success"
      });
    } else {
      this.setState({
        firstnameState: " has-danger"
      });
    }
    this.onChange("name", e.target.value);
  }
  lastNameChange(e) {
    this.setState({
      lastname: e.target.value
    });
    if (e.target.value.length > 2) {
      this.setState({
        lastnameState: " has-success"
      });
    } else {
      this.setState({
        lastnameState: " has-danger"
      });
    }
    this.onChange("lastname", e.target.value);
  }
  lastName2Change(e) {
    this.setState({
      lastname2: e.target.value
    });
    if (e.target.value.length >= 0) {
      this.setState({
        lastname2State: " has-success"
      });
    } else {
      this.setState({
        lastname2State: " has-danger"
      });
    }
    this.onChange("lastname2", e.target.value);
  }
  dniManagerChange(e) {
    e.target.value = this.cleanDNI(e.target.value);

    this.setState({
      dniManager: e.target.value
    });
    if (this.validateDNI(e.target.value)) {
      this.setState({
        dniManagerState: " has-success"
      });
    } else {
      this.setState({
        dniManagerState: " has-danger"
      });
    }
    this.onChange("dniManager", e.target.value);
  }
  firstNameManagerChange(e) {
    this.setState({
      firstnameManager: e.target.value
    });
    if (e.target.value.length > 2) {
      this.setState({
        firstnameManagerState: " has-success"
      });
    } else {
      this.setState({
        firstnameManagerState: " has-danger"
      });
    }
    this.onChange("firstnameManager", e.target.value);
  }
  lastNameManagerChange(e) {
    this.setState({
      lastnameManager: e.target.value
    });
    if (e.target.value.length > 2) {
      this.setState({
        lastnameManagerState: " has-success"
      });
    } else {
      this.setState({
        lastnameManagerState: " has-danger"
      });
    }
    this.onChange("lastnameManager", e.target.value);
  }
  lastName2ManagerChange(e) {
    this.setState({
      lastname2Manager: e.target.value
    });
    if (e.target.value.length >= 0) {
      this.setState({
        lastname2ManagerState: " has-success"
      });
    } else {
      this.setState({
        lastname2ManagerState: " has-danger"
      });
    }
    this.onChange("lastname2Manager", e.target.value);
  }
  emailChange(e) {
    this.setState({
      email: e.target.value
    });
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(e.target.value)) {
      this.setState({
        emailState: " has-success"
      });
    } else {
      this.setState({
        emailState: " has-danger"
      });
    }
    this.onChange("email", e.target.value);
  }
  fiscalIdTypeChange(e) {
    // console.log("######### fiscal ID type change #######");
    // console.log(e);
    this.setState({
      fiscalIdType: e
    });
    if (true) {
      this.setState({
        fiscalIdTypeState: " has-success"
      });
    } else {
      this.setState({
        fiscalIdTypeState: " has-danger"
      });
    }
    this.onChange("fiscalIdType", e);
  }
  formatIBAN(iban) {
    return (iban.replace(/ /g, "").match(/[\s\S]{1,4}/g) || []).join(" ");
  }
  ibanChange(e) {
    let iban = this.formatIBAN(e.target.value);
    this.setState({
      iban: iban
    });
    if (iban === "" || (checkIBAN(iban) && iban.replace(/ /g, "").length === 24)) {
      this.setState({
        ibanState: " has-success"
      });
    } else {
      this.setState({
        ibanState: " has-danger"
      });
    }
    this.onChange("iban", iban);
  }
  mobileChange(e) {
    this.setState({
      mobile: e.target.value
    });
    if (e.target.value.length > 8 && e.target.value.length < 16) {
      this.setState({
        mobileState: " has-success"
      });
    } else {
      this.setState({
        mobileState: " has-danger"
      });
    }
    this.onChange("mobile", e.target.value);
  }
  onChange(field, value) {
    this.props.wizardData.onChange(field, value);
  }
  isValidated() {
    // console.log("############ CONTENIDO FORMULARIO PARA VALIDAR ####################");
    // console.log(this.state);
    let isEnterprise = this.props.wizardData.wizardState.customerType === "90";
    if (
      this.state.firstnameState !== " has-success" ||
      (!isEnterprise && this.state.lastnameState !== " has-success") ||
      (!isEnterprise && this.state.lastname2State !== " has-success") ||
      this.state.emailState !== " has-success" ||
      this.state.dniState !== " has-success" ||
      this.state.mobileState !== " has-success" ||
      (this.props.wizardData.wizardState.customerType === "90" && (
        this.state.firstnameManagerState !== " has-success" ||
        this.state.lastnameManagerState !== " has-success" ||
        this.state.lastname2ManagerState !== " has-success" ||
        this.state.dniManagerState !== " has-success"
      )) /*||
      this.state.ibanState !== " has-success"*/
    ) {
      this.setState({
        firstnameState: " has-danger",
        lastnameState: " has-danger",
        emailState: " has-danger",
        dniState: " has-danger",
        lastname2State: " has-danger",
        mobileState: " has-danger",
        firstnameManagerState: " has-danger",
        lastnameManagerState: " has-danger",
        dniManagerState: " has-danger",
        lastname2ManagerState: " has-danger" /*,
        ibanState: " has-danger"*/
      });
      return false;
    }
    return true;
  }
  render() {
    // console.log("############## RENDER STEP 1 ##################");
    this.props.wizardData.wizardState = this.props.wizardData.getState()
    // console.log(this.props.wizardData.wizardState);
    let fiscalIdTypeField = null;
    let managerFields = null;
    let notEnterpriseFields = null;
    if (this.props.wizardData.wizardState.customerType !== "90") {
      fiscalIdTypeField = (
        <Col xs={12} sm="6">
          <FormGroup>
            <Select
              className="react-select primary"
              classNamePrefix="react-select"
              placeholder="Elegir tipo de documento"
              name="fiscalIdType"
              value={this.props.wizardData.wizardState.fiscalIdType}
              options={fiscalIdType}
              onChange={e => this.fiscalIdTypeChange(e) /*this.setState({ extraExpenseType: value })*/}
            />
          </FormGroup>
        </Col>
      );
      notEnterpriseFields = [];
      notEnterpriseFields.push(
        <Col xs={12} sm="6" key="lastname">
          <InputGroup
            className={
              "form-control-lg" +
              (this.state.lastnameState ? this.state.lastnameState : "") +
              (this.state.lastnameFocus ? " input-group-focus" : "")
            }
          >
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="now-ui-icons text_caps-small" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              value={this.props.wizardData.wizardState.lastname}
              type="text"
              placeholder="Primer apellido"
              name="lastname"
              onFocus={e => this.setState({ lastnameFocus: true })}
              onBlur={e => this.setState({ lastnameFocus: false })}
              onChange={e => this.lastNameChange(e)}
            />
          </InputGroup>
        </Col>
      );
      notEnterpriseFields.push(
        <Col xs={12} sm="6" key="lastname2">
          <InputGroup
            className={
              "form-control-lg" +
              (this.state.lastname2State ? this.state.lastname2State : "") +
              (this.state.lastname2Focus ? " input-group-focus" : "")
            }
          >
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="now-ui-icons text_caps-small" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              value={this.props.wizardData.wizardState.lastname2}
              type="text"
              placeholder="Segundo apellido"
              name="lastname2"
              onFocus={e => this.setState({ lastname2Focus: true })}
              onBlur={e => this.setState({ lastname2Focus: false })}
              onChange={e => this.lastName2Change(e)}
            />
          </InputGroup>
        </Col>
      );
    } else {
      managerFields = (
        <Row className="justify-content-center">
          <Col xs={12} sm="12">
            <h5 className="info-text">Datos del gerente</h5>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.dniManagerState ? this.state.dniManagerState : "") +
                (this.state.dniManagerFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons users_circle-08" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.dniManager}
                type="text"
                placeholder="DNI/NIE/NIF"
                name="dniManager"
                onFocus={e => this.setState({ dniManagerFocus: true })}
                onBlur={e => this.setState({ dniManagerFocus: false })}
                onChange={e => this.dniManagerChange(e)}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.firstnameManagerState ? this.state.firstnameManagerState : "") +
                (this.state.firstnameManagerFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons users_circle-08" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.firstnameManager}
                type="text"
                placeholder="Nombre"
                name="firstnameManager"
                onFocus={e => this.setState({ firstnameManagerFocus: true })}
                onBlur={e => this.setState({ firstnameManagerFocus: false })}
                onChange={e => this.firstNameManagerChange(e)}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.lastnameManagerState ? this.state.lastnameManagerState : "") +
                (this.state.lastnameManagerFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons text_caps-small" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.lastnameManager}
                type="text"
                placeholder="Primer apellido"
                name="lastnameManager"
                onFocus={e => this.setState({ lastnameManagerFocus: true })}
                onBlur={e => this.setState({ lastnameManagerFocus: false })}
                onChange={e => this.lastNameManagerChange(e)}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.lastname2ManagerState ? this.state.lastname2ManagerState : "") +
                (this.state.lastname2ManagerFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons text_caps-small" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.lastname2Manager}
                type="text"
                placeholder="Segundo apellido"
                name="lastname2Manager"
                onFocus={e => this.setState({ lastname2ManagerFocus: true })}
                onBlur={e => this.setState({ lastname2ManagerFocus: false })}
                onChange={e => this.lastName2ManagerChange(e)}
              />
            </InputGroup>
          </Col>
        </Row>
      );
    }
    return (
      <div>
        <h5 className="info-text">Vamos a empezar con la información básica</h5>
        <Row className="justify-content-center">
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.promoCodeState ? this.state.promoCodeState : "") +
                (this.state.promoCodeFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons education_atom" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.promoCode}
                type="text"
                placeholder="Código promocional"
                name="promoCode"
                onFocus={e => this.setState({ promoCodeFocus: true })}
                onBlur={e => this.setState({ promoCodeFocus: false })}
                onChange={e => this.promoCodeChange(e)}
              />
            </InputGroup>
          </Col>
          {fiscalIdTypeField}
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.dniState ? this.state.dniState : "") +
                (this.state.dniFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons users_circle-08" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.dni}
                type="text"
                placeholder={this.props.wizardData.wizardState.customerType !== "90" ? "DNI/NIE/Pasaporte" : "NIF de la empresa"}
                name="dni"
                onFocus={e => this.setState({ dniFocus: true })}
                onBlur={e => this.setState({ dniFocus: false })}
                onChange={e => this.dniChange(e)}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.firstnameState ? this.state.firstnameState : "") +
                (this.state.firstnameFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons users_circle-08" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.name}
                type="text"
                placeholder={this.props.wizardData.wizardState.customerType !== "90" ? "Nombre" : "Nombre de la empresa"}
                name="firstname"
                onFocus={e => this.setState({ firstnameFocus: true })}
                onBlur={e => this.setState({ firstnameFocus: false })}
                onChange={e => this.firstNameChange(e)}
              />
            </InputGroup>
          </Col>
          {notEnterpriseFields}
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.mobileState ? this.state.mobileState : "") +
                (this.state.mobileFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons tech_mobile" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.mobile}
                type="number"
                placeholder="Móvil"
                name="mobile"
                onFocus={e => this.setState({ mobileFocus: true })}
                onBlur={e => this.setState({ mobileFocus: false })}
                onChange={e => this.mobileChange(e)}
              />
            </InputGroup>
          </Col>
          <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.emailState ? this.state.emailState : "") +
                (this.state.emailFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons ui-1_email-85" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.props.wizardData.wizardState.email}
                type="email"
                placeholder="Email"
                name="email"
                onFocus={e => this.setState({ emailFocus: true })}
                onBlur={e => this.setState({ emailFocus: false })}
                onChange={e => this.emailChange(e)}
              />
            </InputGroup>
          </Col>
          {/* <Col xs={12} sm="6">
            <InputGroup
              className={
                "form-control-lg" +
                (this.state.ibanState ? this.state.ibanState : "") +
                (this.state.ibanFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons business_money-coins" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.iban}
                type="text"
                placeholder="Cuenta bancaria"
                name="iban"
                onFocus={e => this.setState({ ibanFocus: true })}
                onBlur={e => this.setState({ ibanFocus: false })}
                onChange={e => this.ibanChange(e)}
              />
            </InputGroup>
          </Col> */}
        </Row>
        {managerFields}
      </div>
    );
  }
}

export default Step1;



// WEBPACK FOOTER //
// ./src/views/Customers/CustomerWizard/CustomerBasicData.jsx